/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfImage } from '../../models/data-page-of-image';

export interface ImageGetAllImageList$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
  pageNumber?: number;
  category?: string | null;
  Category_Name?: string | null;
}

export function imageGetAllImageList(http: HttpClient, rootUrl: string, params?: ImageGetAllImageList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfImage>> {
  const rb = new RequestBuilder(rootUrl, imageGetAllImageList.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('category', params.category, {});
    rb.query('Category_Name', params.Category_Name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfImage>;
    })
  );
}

imageGetAllImageList.PATH = '/image/getAllimagelist';
